import { Inject, Injectable } from "@angular/core";
import { Configuration } from "@/angular-blocworx/components/configuration/services/configuration.service";
import { RequestService } from "@/angular-blocworx/components/configuration/services/request.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class ActivityLogService {
    apiUrl: string;

    constructor(
        @Inject(HttpClient) private http: HttpClient,
        @Inject(Configuration) private configuration: Configuration,
        @Inject(RequestService) private request: RequestService
    ) {
        this.apiUrl = this.configuration.getApiUrl();
    }

    public getLogs(page: number, perPage: number, startDate?: string, endDate?: string): Observable<any> {
        let params = new HttpParams()
            .set("page", page)
            .set("size", perPage);

        if (startDate) params = params.set("startDate", startDate);
        if (endDate) params = params.set("endDate", endDate);

        const headers = this.request.getHeaders();

        return this.http.get(this.apiUrl + "get-activity-logs", { params, headers });
    }
}
